var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49659 8.27979C3.00026 11.3201 2.62954 16.6184 5.66915 20.115C8.70875 23.6116 14.0068 23.9806 17.5041 20.9424C21.0014 17.9043 21.3702 12.6048 18.3306 9.1082C15.291 5.61162 12.1561 3.04013 12.1978 1C10.974 2.81843 7.27921 6.74121 9.01332 11.5508C7.23656 11.0594 6.8673 9.36745 6.49659 8.27979Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.cb2987150c26d567d494d493f75f1a34.svg";
export { ForwardRef as ReactComponent };